import { IVersionsServices } from 'services';
import union from 'lodash.union';
import { VersionItem } from 'store';
import axios from 'axios';

const removePatchAndBuildInfo = (version: string) => {
    const verionsPart = version.split('.');

    return verionsPart.slice(0, verionsPart.length - 2).join('.');
};

class VersionsServices implements IVersionsServices {
    versions: Array<string> = [];
    /**
     * Versions are stored from lower to greater
     */
    processedVersions: Record<string, VersionItem> | null = null;

    getLatest() {
        if (this.versions.length > 0 && this.processedVersions) {
            return this.processedVersions[this.versions[this.versions.length - 1]];
        }

        return null;
    }

    async getVersions() {
        if (this.processedVersions) {
            return this.processedVersions;
        }

        try {
            const response = await axios.get(`https://dcsaascdn.net/aurora/versions.json?${Date.now()}`);

            if (!response.data || !response.data.length) {
                return null;
            }

            const fetchedVersions = response.data;

            fetchedVersions.sort();

            this.versions = union(fetchedVersions.map((version: string) => removePatchAndBuildInfo(version)));
        } catch (e) {
            console.error(e);
        }

        const processed = this.versions.map((version: string) => ({
            id: version,
            text: `${version}.X`,
            value: parseInt(version.split('.').join(''), 10)
        }));

        return (this.processedVersions = processed.reduce(
            (prev, curr: VersionItem) => {
                prev[curr.id] = curr;

                return prev;
            },
            {} as Record<string, VersionItem>
        ));
    }
}

export default VersionsServices;
